import { render, staticRenderFns } from "./login_desktop.vue?vue&type=template&id=1984768d&scoped=true&"
import script from "./login_desktop.vue?vue&type=script&lang=js&"
export * from "./login_desktop.vue?vue&type=script&lang=js&"
import style0 from "./login_desktop.vue?vue&type=style&index=0&id=1984768d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1984768d",
  null
  
)

export default component.exports